import {
  Button,
  cn,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@up2stay/up2promo-ui';
import { useDialogControls } from '@up2promo-setup-frontend/core/hooks/use-dialog-controls';
import { useDictionary } from '@up2promo-setup-frontend/ui/providers/dictionary.provider';

interface MessageModalProps {
  isDestructive?: boolean;
  title?: string;
  bodyText?: string;
}

export default function MessageModal(props: Record<string, unknown> = {}) {
  const {
    isDestructive = false,
    title = 'Info Dialog Title',
    bodyText = 'Inform the user about something important.',
  } = props as MessageModalProps;
  const translations = useDictionary();
  const { open, closeDialog, submitDialog } = useDialogControls();

  return (
    <Dialog
      open={open}
      onOpenChange={(isOpen: boolean) => !isOpen && closeDialog()}
    >
      <DialogContent className="sm:max-w-lg">
        <DialogHeader>
          <DialogTitle className={cn(isDestructive && 'text-destructive')}>
            {title}
          </DialogTitle>
          <DialogDescription className="mt-2">{bodyText}</DialogDescription>
        </DialogHeader>
        <DialogFooter className="mt-6 gap-2">
          {isDestructive && (
            <Button asChild variant="outline">
              <a
                href="https://www.up2promo.com/pages/contact"
                target="_blank"
                rel="noopener noreferrer"
              >
                {translations.general.dialog.contactUs}
              </a>
            </Button>
          )}
          <Button onClick={() => submitDialog(true)}>
            {translations.general.dialog.close}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
